export const getBookingOptionQuantity = (quantities: Record<string, number> | undefined, productId: string): number =>
  Object.prototype.hasOwnProperty.call(quantities ?? {}, productId) ? quantities![productId] : 1;

export const getBookingOptionQuantities = (options: string[] | undefined, quantities?: Record<string, number>): Record<string, number> =>
  Object.fromEntries((options ?? []).map(id => [id, getBookingOptionQuantity(quantities, id)]));